import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import Idle from 'react-idle';

import PinDrawerWithoutButton from './components/PinDrawerWithoutButton/PinDrawerWithoutButton';
import PinModalWithoutButton from './components/PinModalWithoutButton/PinModalWithoutButton';
import ScrollToTop from './components/TradeItem/ScrollToTop';
import ResetPin from './pages/Account/Profile/Modals/ResetPin';

import { RemoveTrailingSlash } from './components/RemoveTrailingSlash/RemoveTrailingSlash';
import useMediaQuery from './Hooks/useMediaQuery';
import { PrivateWrapper } from './PrivateWrapper';

import { routePaths } from './routePaths';
import { resetLoginPin } from './services/AccountApi/profileApi';
import { PIN_VERIFICATION_TYPES } from './utils/constant';
import { formatePhoneNumber } from './utils/formatPhoneNumber';
import { toastNotify } from './utils/toastNotify';

const RouterPath = () => {
  const [openPinModal, setOpenPinModal] = useState(false);
  const [pin, setPin] = useState();
  const [loadingModal, setLoadingModal] = useState(false);
  const [resetPin, setResetPin] = useState(false);
  const [firstTimeOpen, setFirstTimeOpen] = useState(false);
  const { userData: userProfileData, isPinEntered } = useSelector((state) => state.userData);
  const phoneNumber = ['+1', formatePhoneNumber(userProfileData?.phoneNumber)];
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const handleForgotPin = async () => {
    setLoadingModal(true);
    try {
      const resData = await resetLoginPin();
      if (!resData.isError) {
        toastNotify('success', resData?.message);
        setOpenPinModal(false);
        setResetPin(true);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoadingModal(false);
    }
  };
  const handleVerifyPinOpenOrders = () => {
    setOpenPinModal(false);
    localStorage.setItem('restrictPage', false);
    localStorage.removeItem('tabClosingTime');
  };
  useEffect(() => {
    if (localStorage.getItem('restrictPage') === 'true' && isPinEntered) {
      setOpenPinModal(true);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('restrictPage') === 'true' && isPinEntered) {
      setOpenPinModal(true);
      const blockerRoute = localStorage.getItem('blockerRoute');
      if (blockerRoute && blockerRoute !== window.location.href) {
        // Redirect back to the blockerRoute
        window.location.href = blockerRoute;
      }
    }
  }, []);

  useEffect(() => {
    const handleTabClose = (event) => {
      // Cancel the event to prevent the browser from closing immediately
      localStorage.setItem('tabClosingTime', new Date().getTime());
    };
    window.addEventListener('beforeunload', handleTabClose);
    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);

  useEffect(() => {
    const currentTime = new Date().getTime();
    const tabClosingTime = localStorage.getItem('tabClosingTime');
    if (tabClosingTime && isPinEntered) {
      const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
      if (differenceInSeconds > 600) {
        // TODO: 600 NOTE: 30
        setOpenPinModal(true);
        localStorage.setItem('restrictPage', true);
        localStorage.removeItem('tabClosingTime');
      }
    }
  });

  return (
    <BrowserRouter>
      <ScrollToTop />
      <RemoveTrailingSlash />
      {Object.keys(userProfileData).length > 0 && (
        <Idle
          onChange={({ idle }) => {
            if (firstTimeOpen) {
              if (idle && !openPinModal) {
                setOpenPinModal(true);
                localStorage.setItem('blockerRoute', window.location.href);
                localStorage.setItem('restrictPage', true);
              }
            } else {
              setFirstTimeOpen(true);
            }
          }}
          timeout={600000} // TODO:
          // timeout={30000} // TODO:
        />
      )}
      <ResetPin
        phoneNumber={phoneNumber || ''}
        mail={userProfileData?.email || ''}
        setOpen={resetPin}
        setClose={() => {
          setResetPin(false);
          setOpenPinModal(true);
          localStorage.setItem('restrictPage', true);
        }}
      />
      <Routes>
        {routePaths.map((route, index) => {
          const { path, component: Component, exact, isAuth } = route.mainRoute;
          return (
            <Route
              key={index}
              exact={exact}
              path={path}
              element={
                isAuth ? (
                  <PrivateWrapper>
                    <Component />
                    {Object.keys(userProfileData).length > 0 &&
                      openPinModal &&
                      (screenMD ? (
                        <PinModalWithoutButton
                          onCancel={() => {
                            setOpenPinModal(false);
                            localStorage.setItem('restrictPage', false);
                          }}
                          open={openPinModal}
                          pin={pin}
                          loading={loadingModal}
                          handleForgotPin={handleForgotPin}
                          setPin={setPin}
                          setLoading={setLoadingModal}
                          onSuccess={() => {
                            handleVerifyPinOpenOrders();
                          }}
                          isRoute
                          pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                        />
                      ) : (
                        Object.keys(userProfileData).length > 0 &&
                        openPinModal && (
                          <PinDrawerWithoutButton
                            onCancel={() => {
                              setOpenPinModal(false);
                              localStorage.setItem('restrictPage', false);
                            }}
                            open={openPinModal}
                            pin={pin}
                            loading={loadingModal}
                            handleForgotPin={handleForgotPin}
                            setPin={setPin}
                            setLoading={setLoadingModal}
                            onSuccess={() => {
                              handleVerifyPinOpenOrders();
                            }}
                            isRoute
                            setOpen={(value) => setOpenPinModal(value)}
                            pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                          />
                        )
                      ))}
                  </PrivateWrapper>
                ) : (
                  <>
                    {Object.keys(userProfileData).length > 0 &&
                      openPinModal &&
                      (screenMD ? (
                        <PinModalWithoutButton
                          onCancel={() => {
                            setOpenPinModal(false);
                            localStorage.setItem('restrictPage', false);
                          }}
                          open={openPinModal}
                          pin={pin}
                          loading={loadingModal}
                          handleForgotPin={handleForgotPin}
                          setPin={setPin}
                          setLoading={setLoadingModal}
                          onSuccess={() => {
                            handleVerifyPinOpenOrders();
                          }}
                          isRoute
                          pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                        />
                      ) : (
                        Object.keys(userProfileData).length > 0 &&
                        openPinModal && (
                          <PinDrawerWithoutButton
                            onCancel={() => {
                              setOpenPinModal(false);
                              localStorage.setItem('restrictPage', false);
                            }}
                            open={openPinModal}
                            pin={pin}
                            loading={loadingModal}
                            handleForgotPin={handleForgotPin}
                            setPin={setPin}
                            setLoading={setLoadingModal}
                            onSuccess={() => {
                              handleVerifyPinOpenOrders();
                            }}
                            isRoute
                            setOpen={(value) => setOpenPinModal(value)}
                            pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                          />
                        )
                      ))}
                    <Component />
                  </>
                )
              }
            >
              {route.subRoute &&
                route.subRoute.map((subRout1, index) => {
                  const { path, component: Component, exact, isAuth } = subRout1;
                  return (
                    <Route
                      key={index}
                      exact={exact}
                      path={path}
                      element={
                        isAuth ? (
                          <PrivateWrapper>
                            <Component />
                            {Object.keys(userProfileData).length > 0 &&
                              openPinModal &&
                              (screenMD ? (
                                <PinModalWithoutButton
                                  onCancel={() => {
                                    setOpenPinModal(false);
                                    localStorage.setItem('restrictPage', false);
                                  }}
                                  open={openPinModal}
                                  pin={pin}
                                  loading={loadingModal}
                                  handleForgotPin={handleForgotPin}
                                  setPin={setPin}
                                  setLoading={setLoadingModal}
                                  onSuccess={() => {
                                    handleVerifyPinOpenOrders();
                                  }}
                                  isRoute
                                  pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                                />
                              ) : (
                                Object.keys(userProfileData).length > 0 &&
                                openPinModal && (
                                  <PinDrawerWithoutButton
                                    onCancel={() => {
                                      setOpenPinModal(false);
                                      localStorage.setItem('restrictPage', false);
                                    }}
                                    open={openPinModal}
                                    pin={pin}
                                    loading={loadingModal}
                                    handleForgotPin={handleForgotPin}
                                    setPin={setPin}
                                    setLoading={setLoadingModal}
                                    onSuccess={() => {
                                      handleVerifyPinOpenOrders();
                                    }}
                                    isRoute
                                    setOpen={(value) => setOpenPinModal(value)}
                                    pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                                  />
                                )
                              ))}
                          </PrivateWrapper>
                        ) : (
                          <>
                            {Object.keys(userProfileData).length > 0 &&
                              openPinModal &&
                              (screenMD ? (
                                <PinModalWithoutButton
                                  onCancel={() => {
                                    setOpenPinModal(false);
                                    localStorage.setItem('restrictPage', false);
                                  }}
                                  open={openPinModal}
                                  pin={pin}
                                  loading={loadingModal}
                                  handleForgotPin={handleForgotPin}
                                  setPin={setPin}
                                  setLoading={setLoadingModal}
                                  onSuccess={() => {
                                    handleVerifyPinOpenOrders();
                                  }}
                                  isRoute
                                  pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                                />
                              ) : (
                                Object.keys(userProfileData).length > 0 &&
                                openPinModal && (
                                  <PinDrawerWithoutButton
                                    onCancel={() => {
                                      setOpenPinModal(false);
                                      localStorage.setItem('restrictPage', false);
                                    }}
                                    open={openPinModal}
                                    pin={pin}
                                    loading={loadingModal}
                                    handleForgotPin={handleForgotPin}
                                    setPin={setPin}
                                    setLoading={setLoadingModal}
                                    onSuccess={() => {
                                      handleVerifyPinOpenOrders();
                                    }}
                                    isRoute
                                    setOpen={(value) => setOpenPinModal(value)}
                                    pinVerificationType={PIN_VERIFICATION_TYPES.LOGIN}
                                  />
                                )
                              ))}
                            <Component />
                          </>
                        )
                      }
                    />
                  );
                })}
            </Route>
          );
        })}
        <Route path='*' element={<Navigate to='/not-found' replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterPath;
